var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('z-action-picker',{directives:[{name:"zpm",rawName:"v-zpm",value:({
    sectionid: 109,
    areaexposure: 109,
    legoareabackup: {
      sortName: '佩戴效果'
    }
  }),expression:"{\n    sectionid: 109,\n    areaexposure: 109,\n    legoareabackup: {\n      sortName: '佩戴效果'\n    }\n  }"}],attrs:{"get-container":"body","show-btn":false,"height":"80vh","title":"佩戴效果"},on:{"confirm":_vm.openWearPopup,"click-overlay":_vm.openWearPopup},model:{value:(_vm.wearPopupStatus),callback:function ($$v) {_vm.wearPopupStatus=$$v},expression:"wearPopupStatus"}},[_c('WatchIntro',{attrs:{"goodsInfo":_vm.dataInfo,"eventBus":{}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }